import { Playground } from 'docz';
import Frame from "../../../../../src/components/Frame.tsx";
import AreaChart from "../../../../../src/components/AreaChart";
import appleStock from "../../../../../src/data/stock";
import * as React from 'react';
export default {
  Playground,
  Frame,
  AreaChart,
  appleStock,
  React
};